import { styled } from '@mui/material';
import React from 'react';
import { WBContainer, WBDialogContent, WBFlex } from '@admiin-com/ds-web';
import { Dialog as MUIDialog } from '@mui/material';
import { TaskCreateModalProps } from './type';
import TaskCreateHeader from './components/Header';
import { Content } from './components/Content';

const StyledDialog = styled(MUIDialog)({
  '& .MuiDialogContent-root': {
    width: '100%',
  },
  '& .MuiPaper-root': {
    overflow: 'hidden',
  },
});
const StyledWBFlex = styled(WBFlex)(({ theme }) => ({
  flexDirection: 'column',
  flex: 1,
  alignItems: 'center',
  height: '100%',
  backgroundColor: theme.palette.background.default,
}));

export function TaskCreateModal({
  onClose,
  page,
  setPage,
  open,
  isEditing,
  onSignatureCreated,
  taskDirection,
  createdTask,
  binding,
  taskType,
  isBinding,
  taskProps,
}: TaskCreateModalProps) {
  return (
    <StyledDialog
      fullScreen
      onClose={onClose}
      aria-labelledby="customized-dialog-title"
      open={open}
      scroll="body"
    >
      <StyledWBFlex>
        <TaskCreateHeader
          open={open}
          onClose={onClose}
          isEditing={isEditing}
          setPage={setPage}
          page={page}
          taskType={taskType}
          isBinding={isBinding}
          taskProps={taskProps}
        />
        <WBDialogContent dividers>
          <ContentContainer
            maxWidth="xl"
            sx={{ height: '100%', px: [0, 0], py: [1, 0] }}
          >
            <Content
              page={page}
              setPage={setPage}
              open={open}
              isEditing={isEditing}
              onSignatureCreated={onSignatureCreated}
              taskDirection={taskDirection}
              createdTask={createdTask}
              onClose={onClose}
              taskType={taskType}
              isBinding={isBinding}
              binding={binding}
            />
          </ContentContainer>
        </WBDialogContent>
      </StyledWBFlex>
    </StyledDialog>
  );
}

const ContentContainer = styled(WBContainer)(({ theme }) => ({
  [theme.breakpoints.down('sm')]: {
    padding: theme.spacing(0),
  },
}));
export default TaskCreateModal;
